<template>
    <form class="select" @mouseleave="open = false" @submit.prevent="search">
        <input type="text" v-model="term">
        <button type="submit"></button>
    </form>
</template>

<script>
    export default {
        name: 'FooterSearch',
        data() {
            return {
                term: ""
            }
        },
        methods: {
            search() {
                this.$router.replace({query: {search: this.term}})
            },
        },
        async mounted() {
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '@/assets/scss/colors';
@import '@/assets/scss/fonts';

$font-size: .75rem;
a {
  color: $color-white;
  text-decoration: none;
}

.select {
    input {
        font-family: $ff-detail;
        font-size: $font-size;
        color: $color-white;
        border: 2px solid $color-white;
        padding: 1em 1em calc(1em * .8);
        display: flex;
        background-color: transparent;
        width: 100%;
        outline: none;
        font-weight: 500;

        &:active, &:focus {
            background-color: white;
            color: $color-background;
        }
    }

    button {
        display: none;
    }

}

</style>
